// import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import TextField from "@mui/material/TextField";
// import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
// import Avatar from "@mui/material/Avatar";
// import Button from "@mui/material/Button";
// import { useNavigate, useLocation } from "react-router-dom";
// import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
// import { OTP_SCREEN_ROUTE } from "../routes";
// import AppForm from "../components/forms/AppForm";
// import { loginValidationSchema } from "../components/forms/validationSchemas";
// import { useAppDispatch, useAppSelector } from "../app/hooks";
// import LoadingSpinner from "../components/common/Loading";
// import AppErrorMessage from "../components/common/AppErrorMessage";
// import FormInput from "../components/forms/FormInput";
// import { login } from "../features/auth/authSlice";

// const initialValues: any = {
//   user_id: "",
// };

// const LoginScreen = () => {
//   const { state }: any = useLocation();

//   const navigate = useNavigate();
//   const { isLoading, isLoginError, loginMessage } = useAppSelector(
//     (state) => state?.auth
//   );
//   const dispatch = useAppDispatch();

//   const handleSubmit = (prop: any) => {
//     let obj = prop;
//     // obj.role = !state ? "clinic_owner" : state.state;
//     obj.role = "clinic_owner";
//     dispatch(login(obj))?.then((res) => {
//       if (res?.payload?.success === true) {
//         navigate(OTP_SCREEN_ROUTE, { state: state });
//       }
//     });
//   };

//   return (
//     <Container component="main" maxWidth="xs">
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           minHeight: "80vh",
//         }}
//       >
//         <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
//           <LockOutlinedIcon />
//         </Avatar>
//         <Typography sx={{ pb: 3 }} component="h1" variant="h5">
//           Sign in
//         </Typography>
//         <AppForm
//           validationSchema={loginValidationSchema}
//           initialValues={initialValues}
//           onSubmit={handleSubmit}
//         >
//           <Grid container spacing={2}>
//             <Grid item xs={12}>
//               <FormInput
//                 name="user_id"
//                 as={TextField}
//                 label="Phone number"
//                 fullWidth
//               />
//             </Grid>
//             <Grid item xs={12}>
//               {isLoginError && <AppErrorMessage message={loginMessage} />}
//             </Grid>

//             <Grid item xs={12}>
//               {isLoading ? (
//                 <LoadingSpinner />
//               ) : (
//                 <Button
//                   type="submit"
//                   fullWidth
//                   variant="contained"
//                   sx={{ mb: 2 }}
//                 >
//                   Sign In
//                 </Button>
//               )}
//             </Grid>
//           </Grid>

//           <Grid container justifyContent="flex-end">
//             <Grid item>
//               <Typography variant="body2">
//                 {"Don't have an account? Sign Up"}
//               </Typography>
//             </Grid>
//           </Grid>
//         </AppForm>
//       </Box>
//     </Container>
//   );
// };

// export default LoginScreen;

import React, { useState } from "react";
import Box from "@mui/material/Box";
import LoginForm from "../components/login/signup/loginForm";

const LoginScreen = () => {
  return (
    <Box>
      <LoginForm />
    </Box>
  );
};

export default LoginScreen;
